// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"94906ba3","703":"7feca027"}[chunkId] + ".chunk.js";
};